module.exports = __webpack_public_path__ + "img/fi-zip.5d81c75d.svg";